// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f98407b3","977":"f907ae47"}[chunkId] + ".chunk.js";
};